// Create an empty array consisting five items.
// When the preferences are being loaded,
// it will be used as a placeholder skeleton.
export default function generatePlaceholderArray(unique, limit) {
  const placeholders = [];
  for (let i = 0; i < limit; i += 1) {
    placeholders.push({ [unique]: `placeholder ${i}` });
  }

  return placeholders;
}
